import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nestedFolder'
})
export class NestedFolderPipe implements PipeTransform {

  transform(path: string, type: 'last' | 'except-last'): string {
    const [ lastElem, ...args ] = path.split('/').reverse();

    return type === 'last' ? lastElem : args.join('/');
  }

}
